var CatListModule = (function() {
    var catlist = document.getElementById('catlist');

    function toggleList() {
        if (catlist.style.display === 'none') {
            catlist.style.display = 'grid';
        } else {
            catlist.style.display = 'none';
        }
    }

    return {
        init: function() {
            var opencatlist = document.getElementById('opencatlist');
            opencatlist.addEventListener('click', toggleList);
        }
    };
})();

export default CatListModule
